import { GENDER, TAG_TYPE } from '@/constants';
import { request, createSourceFormDialog } from 'beans-admin-plugin';
import { Message } from 'element-ui';
import _ from 'lodash';

export default function({ tags = [], actionColumn = {} } = {}) {
  return [
    {
      prop: 'id',
      label: '编号',
      width: 80,
      action: ['hide-in-detail']
    },
    {
      prop: 'no',
      label: '唯一编号'
    },
    {
      prop: 'nickname',
      label: '用户名'
    },
    {
      prop: 'real_name',
      label: '真实姓名'
    },
    {
      prop: 'avatar',
      label: '头像',
      renderCell: {
        type: 'image',
        borderRadius: '50%'
      }
    },
    {
      prop: 'gender',
      label: '性别',
      width: 60,
      renderCell(h, { row }) {
        if (GENDER[row.gender]) {
          return <el-tag type={TAG_TYPE[row.gender]} size="mini">{GENDER[row.gender]}</el-tag>
        }
      }
    },
    {
      prop: 'is_distributor',
      label: '是否分销商',
      renderCell: {
        type: 'bool',
        size: 'mini'
      }
    },
    {
      prop: 'is_employee',
      label: '是否员工',
      renderCell: {
        type: 'bool',
        size: 'mini'
      }
    },
    {
      prop: 'valid_order_count',
      label: '成交订单笔数',
      sort: 'order_by',
      minWidth: 110
    },
    {
      prop: 'visited_color_product_count',
      label: '浏览的产品数量',
      sort: 'order_by',
      minWidth: 120
    },
    {
      prop: 'followed_color_product_count',
      label: '关注的产品数量',
      sort: 'order_by',
      minWidth: 120
    },
    {
      prop: 'tag_list',
      label: '标签列表',
      width: 300,
      renderCell(h, { row }) {
        return (row.tag_list || []).map(li => <el-tag size="mini" style="margin-right: 10px;">{li}</el-tag>)
      }
    },
    {
      prop: 'created_at',
      label: '创建时间',
      action: ['hide-in-table'],
      renderCell: 'time',
      sort: 'order_by'
    },
    {
      prop: 'updated_at',
      label: '最后更新时间',
      action: ['hide-in-table'],
      renderCell: 'time'
    },
    _.merge({
      prop: 'action',
      label: '操作',
      fixed: 'right',
      width: 150,
      detail: true,
      edit: false,
      extraAction: (h, { row }) => {
        const editUserTags = async(h) => {
          const columns = [
            {
              prop: 'tag_list',
              label: '标签',
              form: {
                component: 'select',
                props: {
                  options: tags.map(tag => ({ label: tag, value: tag })),
                  multiple: true,
                  filterable: true,
                  'default-first-option': true,
                  'allow-create': true,
                  placeholder: '请添加标签',
                  defaultValue: row.tag_list
                }
              }
            }
          ];

          const onConfirm = async (data) => {
            const id = row.id;
            await request.put(`/users/${id}/tags`, { tag_list: data.tag_list.join('|') });
            Message.success('更新用户标签完成');
            this.fetchData();
          }
          createSourceFormDialog(h, {
            title: '编辑用户标签',
            columns,
            onConfirm,
            customClass: 'w-30 min-w-400'
          })
        }

        const toggleIsEmployee = async(text) => {
          await this.$confirm(`是否确定${text}内部员工？`, text);
          await this.$request.put(`/users/${row.id}/toggle_is_employee`);
          Message.success('操作完成');
          this.fetchData();
        }

        const toggleIsDistributor = async(text) => {
          await this.$confirm(`是否确定${text}分销商？`, text);
          await this.$request.put(`/users/${row.id}/toggle_is_distributor`);
          Message.success('操作完成');
          this.fetchData();
        }

        return [
          {
            text: '编辑标签',
            handler: editUserTags
          },
          row.is_employee && {
            text: '取消员工',
            handler: () => toggleIsEmployee('取消')
          },
          !row.is_employee && {
            text: '设置为员工',
            handler: () => toggleIsEmployee('设置为')
          },
          row.is_distributor && {
            text: '取消分销商',
            handler: () => toggleIsDistributor('取消')
          },
          !row.is_distributor && {
            text: '成为分销商',
            handler: () => toggleIsDistributor('设置为')
          }
        ]
      }
    }, actionColumn)
  ];
}
